module.exports = __webpack_public_path__ + "static/img/icon_info.13b00438.png";